(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["goyu-language-options"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('.goyu-language-form')) return;
    var returnTo = form.querySelector('[name="return_to"]');
    if (returnTo) {
      returnTo.value = window.location.pathname + window.location.search + window.location.hash;
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["goyu-pdp-gallery-scripts"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-pdp-gallery]').forEach(function (galleryEl) {
      var track = galleryEl.querySelector('[data-slider-track]');
      var prevBtn = galleryEl.querySelector('[data-slider-prev]');
      var nextBtn = galleryEl.querySelector('[data-slider-next]');
      if (!track) return;

      var wrapper = galleryEl.closest('.product__visual-wrapper') || galleryEl.parentElement;
      var thumbsRoot = wrapper ? wrapper.querySelector('[data-gallery-thumbs]') : null;
      var thumbBtns = thumbsRoot ? Array.prototype.slice.call(thumbsRoot.querySelectorAll('[data-goto]')) : [];
      var dotsRoot = galleryEl.querySelector('[data-gallery-dots]');
      var slides = Array.prototype.slice.call(track.children);

      function step() {
        var slide = track.querySelector('.pdp-gallery__slide');
        return slide ? slide.getBoundingClientRect().width : track.clientWidth;
      }

      function updateArrows() {
        if (!prevBtn || !nextBtn) return;
        var maxScroll = track.scrollWidth - track.clientWidth - 1;
        prevBtn.disabled = track.scrollLeft <= 0;
        nextBtn.disabled = track.scrollLeft >= maxScroll;
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          track.scrollBy({ left: -step(), behavior: 'smooth' });
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          track.scrollBy({ left: step(), behavior: 'smooth' });
        });
      }
      track.addEventListener('scroll', updateArrows, { passive: true });
      updateArrows();

      if (dotsRoot && slides.length > 1) {
        slides.forEach(function (slide, i) {
          var dot = document.createElement('span');
          dot.className = 'pdp-gallery__dot';
          if (i === 0) dot.classList.add('is-active');
          dotsRoot.appendChild(dot);
        });
      }
      var dots = dotsRoot ? Array.prototype.slice.call(dotsRoot.children) : [];

      thumbBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var slide = track.children[Number(btn.dataset.goto)];
          if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        });
      });

      var warmed = {};
      function warmSlide(i) {
        var slide = slides[i];
        if (!slide || warmed[i]) return;
        var img = slide.querySelector('img[loading="lazy"]');
        if (!img) return;
        warmed[i] = true;
        var preload = new Image();
        if (img.sizes) preload.sizes = img.sizes;
        if (img.srcset) preload.srcset = img.srcset;
        preload.src = img.src;
      }

      if (slides.length && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.intersectionRatio < 0.6) return;
            var i = Number(entry.target.dataset.index);
            thumbBtns.forEach(function (b, n) {
              if (n === i) { b.setAttribute('aria-current', 'true'); } else { b.removeAttribute('aria-current'); }
            });
            dots.forEach(function (d, n) {
              d.classList.toggle('is-active', n === i);
            });
            warmSlide(i + 1);
            warmSlide(i + 2);
          });
        }, { root: track, threshold: [0.6] });
        slides.forEach(function (slide) { io.observe(slide); });
      }

      document.addEventListener('pdp-gallery:variant-change', function (e) {
        var detail = e.detail || {};
        var media = detail.variant && detail.variant.featured_media;
        if (!media || !detail.section) return;
        var target = track.querySelector('[data-media-id="' + detail.section + '-' + media.id + '"]');
        if (target) track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
